export default "/_next/static/data/personalization-takes-lottie.json-28be060930d5273258f070b57014f62d.json";